module.exports = __webpack_public_path__ + "static/media/Banner-informacion-de-credito-2.44b4dbd7.png";